import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=6b7427a3&scoped=true&"
import script from "./DeleteDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDialog.vue?vue&type=style&index=0&id=6b7427a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7427a3",
  null
  
)

export default component.exports